import React from 'react';
import PropTypes from 'prop-types';
import useTranslate from '~hooks/useTranslate/useTranslate';
import { getRating } from '~helpers/rating';

import styles from './one-star.module.scss';

const OneStar = ({
  rating,
  numOfStars = 5,
  active = true,
  showLabel = false,
  showLabelMiddle = false,
  icon = null,
  showDecimal = false,
  showRoundedRating = false,
}) => {

  const ratingText = useTranslate('rating', 'Rating:');

  return (
    <div className={`${styles.starRatingContainer || ''} ${!active && (styles.inactive || '')} 
    ${showLabelMiddle && (styles.labelMiddle || '')}`}
    >
      {showLabel && <span>{ratingText}</span>}
      {!icon ? <span className={styles.fullStar || ''} /> : icon}
      {showDecimal
        ? getRating(rating, showRoundedRating).toFixed(1)
        : getRating(rating, showRoundedRating)}
      <span>/</span>
      <span>{numOfStars}</span>
    </div>
  );
};

OneStar.propTypes = {
  numOfStars: PropTypes.oneOf([5, 10]),
  rating: PropTypes.oneOfType([PropTypes.array, PropTypes.number, PropTypes.string]).isRequired,
  active: PropTypes.bool,
  showLabel: PropTypes.bool,
  icon: PropTypes.element,
  showDecimal: PropTypes.bool,
  showRoundedRating: PropTypes.bool,
  showLabelMiddle: PropTypes.bool,
};

export default OneStar;
